import {
    Brain, Search, Globe, Database, GitFork, Workflow, Zap, Settings as Cog
} from 'lucide-react';

/** Step kind metadata — icons, tones, and labels for lists and the kind picker. */
export const STEP_KINDS = [
    {
        kind: 'llm',
        label: 'LLM',
        icon: Brain,
        color: 'text-violet-500',
        bgColor: 'bg-violet-500/10'
    },
    {
        kind: 'rag',
        label: 'RAG',
        icon: Search,
        color: 'text-blue-500',
        bgColor: 'bg-blue-500/10'
    },
    {
        kind: 'api',
        label: 'API',
        icon: Globe,
        color: 'text-green-500',
        bgColor: 'bg-green-500/10'
    },
    {
        kind: 'tool',
        label: 'Tool',
        icon: Cog,
        color: 'text-orange-500',
        bgColor: 'bg-orange-500/10'
    },
    {
        kind: 'memory',
        label: 'Memory',
        icon: Database,
        color: 'text-amber-500',
        bgColor: 'bg-amber-500/10'
    },
    {
        kind: 'choose',
        label: 'Choose',
        icon: GitFork,
        color: 'text-rose-500',
        bgColor: 'bg-rose-500/10'
    },
    {
        kind: 'subflow',
        label: 'SubFlow',
        icon: Workflow,
        color: 'text-cyan-500',
        bgColor: 'bg-cyan-500/10'
    },
    {
        kind: 'parallel',
        label: 'Parallel',
        icon: Zap,
        color: 'text-fuchsia-500',
        bgColor: 'bg-fuchsia-500/10'
    }
    // 'call' kind gated — see featureFlags.ts (Project O runtime not registered).
];

export const KIND_INDEX = Object.fromEntries(STEP_KINDS.map((k) => [k.kind, k]));
